export const callbackResponse = `
{
  "JobId": Number,
  "JobName": String
  "EncodingOutputJobId": Number,
  "Status": Number,
  "MessageComment": String
}
`
